export default function hasConnections(connectionsData) {
  return !!connectionsData && Object.keys(connectionsData).length > 0;
}
